import he from '@/translations/he';
import en from '@/translations/en';

export default {
  he,
  en,
};
